
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notice/detail",
      function () {
        return require("private-next-pages/notice/detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notice/detail"])
      });
    }
  